import { useParams } from "react-router-dom";
import { useCompanySettings } from "../../../hooks";

export const useIsWhitelistEnabled = (): boolean => {
  const { companyId } = useParams();
  const { isWhitelistEnabled } = useCompanySettings({ companyId });

  return isWhitelistEnabled;
};
